exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.resources-manager__panel-holder.closed[data-v-0672c702] {\n  max-height: 0;\n  overflow: hidden;\n}\n.resources-manager__share-type--limited-width[data-v-0672c702] {\n  max-width: 88%;\n}\ntable tr th[data-v-0672c702], table tr td[data-v-0672c702] {\n  vertical-align: middle;\n}\n.table tbody tr[data-v-0672c702]:hover {\n  border: none;\n  transform: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0672c702","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventory/products/components/ResourcesManager.vue
// module id = 1576
// module chunks = 0